import TR from 'utils/TR';
import T from 'utils/T';
import ex from 'utils/ex';
import React from 'react';
import Segment from 'components/common/Segment';
import AbnormalBloodGlocoseBoxChart from 'components/charts/AbnormalBloodGlocoseBoxChart';
import SummaryBloodGlocoseCountBox from 'components/common/SummaryBloodGlocoseCountBox';
import HBox from 'components/common/HBox';
import VBox from 'components/common/VBox';
import CaptionBox from 'components/common/CaptionBox';
import Ratiobar from 'components/charts/Ratiobar';
import AbnormalBloodGlocoseBoxTable from './AbnormalBloodGlocoseBoxTable';

const codes = [
  '새벽',
  '오전',
  '오후',
  '저녁'
];
export default function AbnormalBloodGlocoseBox(props) {
  const {
    renderAll,
    front,
    data,
    ...rest
  } = props || {};

  const {
    abnormal_bld_sugr_stats_list = [],
    abnormal_bld_sugr_list,
  } = data || {};

  const hash = React.useMemo(() => abnormal_bld_sugr_stats_list.reduce((a, c) => {
    return ({
      ...a,
      [codes[+c.time_cd - 1]]: {
        high: c.high_bld_sugr_cnt,
        low: c.low_bld_sugr_cnt
      },
      Total: {
        high: a.Total.high + c.high_bld_sugr_cnt,
        low: a.Total.low + c.low_bld_sugr_cnt,
      }
    });
  }, {
    Total: { high: 0, low: 0 },
  }), [abnormal_bld_sugr_stats_list]);

  return (
    <Segment {...ex('AbnormalBloodGlocoseBox', rest)}>
      <HBox full>
        <VBox>
          <HBox center>
            <CaptionBox {...ex('mini', { caption: T('전체') })} />
          </HBox>
          <VBox full>
            <Ratiobar
              {...{
                limits: [hash.Total.high, hash.Total.low],
                values: [hash.Total.high, hash.Total.low],
                colors: ['#FF995A', '#5D3FC5'],
                maxHeight: 110,
              }}
            />
          </VBox>
        </VBox>
        <VBox full>
          <HBox>
            <AbnormalBloodGlocoseBoxTable {...{ hash }} />
          </HBox>
          <VBox full>
            <AbnormalBloodGlocoseBoxChart {...rest} {...{ list: abnormal_bld_sugr_list }} />
          </VBox>
        </VBox>
      </HBox>
    </Segment>
  );
}
